import { render, staticRenderFns } from "./review-goods-iframe.vue?vue&type=template&id=e4b87b88&"
import script from "./review-goods-iframe.vue?vue&type=script&lang=js&"
export * from "./review-goods-iframe.vue?vue&type=script&lang=js&"
import style0 from "./review-goods-iframe.vue?vue&type=style&index=0&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports